import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { TIMELINE } from "@/data/content";
import { Reveal } from "./Reveal";
import { FounderPhoto } from "./FounderPhoto";

const Chapter = ({ c, i }) => (
  <Reveal data-testid={`timeline-step-${i}`} className="grid grid-cols-1 sm:grid-cols-[minmax(160px,220px)_1fr] gap-3 sm:gap-10 py-10 border-b border-[#1B1530]/15">
    <div className="font-display text-7xl sm:text-8xl leading-none text-[#FF5A5F]">{c.big}</div>
    <div>
      <p className="eyebrow text-[#4A4560] mb-2">{c.tag}</p>
      <h3 className="font-display text-3xl sm:text-4xl leading-none mb-3">{c.title}</h3>
      <p className="text-base sm:text-lg text-[#1B1530]/80 leading-relaxed max-w-xl">{c.body}</p>
      {c.img && (
        <div className={`mt-6 rounded-[24px] overflow-hidden bg-white ${c.portrait ? "aspect-[3/4] max-w-sm" : "aspect-[4/3] max-w-xl"}`}>
          <img src={c.img} alt={c.imgAlt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
        </div>
      )}
    </div>
  </Reveal>
);

export const Story = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section ref={ref} data-testid="founder-story-section" className="pb-24 lg:pb-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <FounderPhoto />
            <blockquote className="mt-14 font-display text-2xl sm:text-3xl leading-tight max-w-md">"Why should fueling your body feel like a chore?"</blockquote>
            <p className="mt-2 eyebrow text-[#4A4560]">Rory, age 14</p>
          </div>
        </div>
        <div className="lg:col-span-7 relative pl-6 sm:pl-10">
          <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-[#1B1530]/10 rounded-full" />
          <motion.div style={{ scaleY }} className="absolute left-0 top-0 bottom-0 w-[3px] bg-[#FF5A5F] origin-top rounded-full" />
          {TIMELINE.map((c, i) => <Chapter key={c.big} c={c} i={i} />)}
          <Reveal className="pt-12">
            <p className="font-display text-4xl sm:text-5xl leading-[0.95]">Still 18. Still building.<br /><span className="text-[#FF5A5F]">Every bag helps write the next chapter.</span></p>
            <Link to="/shop" data-testid="story-shop-cta" className="mt-8 inline-grid place-items-center h-14 px-8 rounded-full bg-[#1B1530] text-white font-bold hover:bg-[#FF5A5F] transition-colors">Support the dream · Shop now</Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
